
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Pages from '.';

export default function RouterConfig() {
  return (
    <Router basename="/store">
      <Pages />
    </Router>
  );
}
